import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
    settings: {
        display: 'inline-flex',
        justifyContent: 'center',
        flexDirection: 'row',
        textAlign: 'center',
        },
    });